/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { mediaImageUpload } from '../../axios/mediaImageUpload'
import type {
	MediaImageUploadError,
	MediaImageUploadPathParams,
	MediaImageUploadRequest,
	MediaImageUploadResponse,
} from '../../types/MediaImageUpload'

export const mediaImageUploadMutationKey = () => [{ url: '/media/:organisation/images' }] as const

export type MediaImageUploadMutationKey = ReturnType<typeof mediaImageUploadMutationKey>

export type MediaImageUploadVariables = {
	organisation: MediaImageUploadPathParams['organisation']
	data: MediaImageUploadRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::upload */
export function useMediaImageUpload<TContext = unknown>(
	options?: UseMutationOptions<
		MediaImageUploadResponse,
		AxiosError<MediaImageUploadError>,
		MediaImageUploadVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: mediaImageUploadMutationKey(),
		mutationFn: ({ organisation, data }: MediaImageUploadVariables) =>
			mediaImageUpload(organisation, data, config).then(res => res.data),
		...options,
	})
}
